// list des jobs et avec leurs informations d'exécution
export class SchedulerResultData {
  rowId: number;
  jobName: string;
  groupName: string;
  jobType: string;
  scheduleTime: Date;
  lastFiredTime: Date;
  nextFireTime: Date;
  jobStatus: string;
  cronExpression: string;
}

export class ScheduleRequest {
  jobClass: string;
  jobName: string;
  cronExpression: string;
  jobScheduleTime: string;
}

export class ScheduleUpdateRequest {
  jobName: string;
  cronExpression: string;
  jobScheduleTime: string;
}

